<template>
  <div>
    <div class="bk">
      <!-- zz -->
      <div class="overlay"></div>
      <div class="one">城市与建筑智能化</div>
      <div class="xian"></div>

      <div class="two">
        城市与建筑智能化是一个跨学科、多层次的概念，其核心目标是通过先进的信息技术和数据分析手段，提高城市与建筑的运营效率，改善民众的生活质量。城市与建筑智能化不仅仅是硬件与软件的升级，更是一种综合性的解决方案，使用了包括但不限于物联网（IoT）技术、大数据分析、云计算和人工智能决策等。
        <!-- 根据不同的需求与场景，城市与建筑智能化的建设/改造，包括但不限于以下的内容：安防监控，停车场管理，门禁管理，道闸管理，综合布线，楼宇自动化控制，广播管理，计算机系统管理，综合物业管理，中央空调管理，应急管理，计算机机房管理，车流管理，人流管理，给排水等 -->
      </div>
    </div>

    <div class="cecurity">
      <div class="title">城市智能化</div>
      <div class="content">
        <span>
          涵盖了所有以行政区域（省/市/县/区等）为层级的智能化建设/改造业务，包括但不限于地铁站，道路监测，公共停车场，水利，林业，农业等；在此业务线中，昌恩较有代表性的案例有广东省和平县公安局交通警察大队电子警察系统工程、福田区天健商务大厦停车场、深圳坪山新区燕子岭配套员工宿舍停车场、宝安区福永文化中心地下停车场、宝安沙井新桥村民住宅统建楼停车场、广东梅州幸福家园地下停车场、浙江省东阳市老公安局智能停车场等。
        </span>
      </div>
      <!-- <div class="look">
        <router-link :to="{ path: '/security' }">
          <span @click="goT()">查看更多</span>
          <img src="../assets/img/icon_more.svg" alt="" />
        </router-link>
      </div> -->
    </div>
    <div class="three">
      <div></div>
      <!-- <div></div> -->
      <div></div>
    </div>

    <div class="architecture">
      <div class="title">园区智能化</div>
      <div class="content">
        <span>
          涵盖了一切有明确范围边界，由多个设施或建筑汇集形成的园区下的智能化建设/改造业务，包括但不限于大型医院，大型校园，工业园，产业园，科技园，保税区等；在此业务线中，昌恩较有代表性的案例有：前海人寿广州总医院、龙岗区人民医院健康管理中心大楼、深圳市宝安区中心医院、深圳市第二人民医院、贵州贵安职业学院、深圳职业技术学院、深圳松岗中学、西乡中学、华侨城中学、深圳劲嘉工业园、青岛嘉颐泽工业园、中丰田光电（珠海）工业园、深圳大百汇高新技术产业园等。</span
        >
      </div>
      <!-- <div class="look">
        <span
          ><router-link :to="{ path: '/jianzhu' }">查看更多</router-link></span
        >
        <img src="../assets/img/icon_more.svg" alt="" />
      </div> -->
    </div>
    <div class="four">
      <div></div>
      <div></div>
      <!-- <div></div> -->
      <div></div>
    </div>
    <div class="air">
      <div class="title">建筑智能化</div>
      <div class="content">
        <span>
          涵盖了单一楼宇内的所有智能化与机电的建设/改造业务，包括但不限于写字楼，居民楼，海关关口，博物馆，美术馆，银行等；在此业务线中，昌恩较有代表性的案例有：上海建滔广场、中铁海南诺德丽湖半岛酒店、深汕合作区海洋产业研发中心酒店、
          文锦渡海关、贵州武警总队、大百汇广场、河南平顶山市博物馆、上海银行深圳分行、平安银行厦门分行、东莞银行总行等。</span
        >
      </div>
      <!-- <div class="look">
        <span><router-link :to="{ path: '/air' }">查看更多</router-link></span>
        <img src="../assets/img/icon_more.svg" alt="" />
      </div> -->
    </div>
    <div class="airthree">
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    // 执行路由进入时的滚动操作
    window.scrollTo({ top: 0 })
    next()
  },
  name: 'architecture',
  data () {
    return {}
  },
  methods: {
    goT () {
      console.log('===============')
    }
  }
}
</script>

<style scoped>
.look {
  position: absolute;
}
.bk {
  position: relative;
  width: 100vw;
  height: 104vw;
  /* background-image: url(../assets/img/建筑智能化_banner_mob.png); */
  background-image: url(../assets/img/智能安防1_mob.png);
  background-size: cover;
  background-color: rgba(176, 183, 213, 0.2);
}
.overlay {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 104vw;
  background: rgba(10, 11, 21, 0.4);
}
.bk .one {
  position: absolute;
  top: 34.1333vw;
  left: 50%;
  transform: translate(-50%, 0px);
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 8.6667vw;
  letter-spacing: 1.6vw;
  font-size: 6.4vw;
  white-space: nowrap;
}
.bk .xian {
  position: absolute;
  top: 48.8vw;
  width: 97.3333vw;
  height: 0px;
  border: 1px solid;
  border-image: linear-gradient(
      90deg,
      rgba(255, 166, 3, 0),
      rgba(255, 166, 3, 1),
      rgba(255, 166, 3, 0)
    )
    3 3;
}
.bk .two {
  position: absolute;
  width: 89.3333vw;
  height: 17.4667vw;
  top: 56.8vw;
  left: 5.3333vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  letter-spacing: 0.1333vw;
  font-size: 3.2vw;
  text-align: center;
  line-height: 5.3333vw;
}

.cecurity {
  position: relative;
  margin: 8vw auto 0px;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}

.cecurity .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
  /* padding-top: 7.4667vw; */
  padding-top: 6.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  color: #140047;
  font-size: 5.0667vw;
  font-family: AlibabaPuHuiTiB;
}
.cecurity .content {
  /* padding-top: 18.4vw; */
  padding-top: 16vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
}
.cecurity .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  color: #01021b;
  opacity: 0.72;
  font-family: PingFangSC-Regular, PingFang SC;
}
.cecurity .look {
  width: 29.3333vw;
  height: 8vw;
  margin-top: 16px;
  margin-left: 33.7333vw;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5333vw;
  border: 0.2667vw solid #140047;
}
.cecurity .look span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
}
.three {
  margin: 4.2667vw auto 0px;
  width: 92vw;
  height: 69.0667vw;
}

.three div:nth-child(1) {
  float: left;
  left: 0px;
  width: 43.7333vw;
  height: 69.0667vw;
  /* background-image: url(../assets/img/智能安防1_mob.png); */
  background-image: url(../assets/img/城市智能化1.png);
  background-size: 100% 100%;
  background-size: cover;
  background-position: center;
  /* border: 1px dashed #808080; */
}
/* .three div:nth-child(2) {
  float: right;
  top: 0px;
  right: 0px;
  width: 44.2667vw;
  height: 32.5333vw;
  background-image: url(../assets/img/智能安防2_mob.png);
  background-size: 100% 100%;
} */
.three div:nth-child(2) {
  float: right;
  /* margin-top: 4vw; */
  right: 0px;
  width: 44.2667vw;
  /* height: 32.5333vw; */
  height: 100%;
  background-image: url(../assets/img/智能安防3_mob.png);
  /* background-size: 100% 100%; */
  background-size: cover;
  background-position: center;
  /* border: 1px dashed #808080; */
}
.architecture {
  position: relative;
  margin: 10.6667vw auto 0px;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}
.architecture .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
  /* padding-top: 7.4667vw; */
  padding-top: 4.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  color: #140047;
  font-size: 5.0667vw;
  font-family: AlibabaPuHuiTiB;
}
.architecture .content {
  /* padding-top: 18.4vw; */
  padding-top: 10.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
}
.architecture .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  color: #01021b;
  opacity: 0.72;
  font-family: PingFangSC-Regular, PingFang SC;
}
.architecture .look {
  width: 29.3333vw;
  height: 8vw;
  margin-top: 16px;
  margin-left: 33.7333vw;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5333vw;
  border: 0.2667vw solid #140047;
}
.look span {
  float: left;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
}
.look img {
  float: left;
  width: 8vw;
  height: 8.5333vw;
  margin-left: 2.6667vw;
}
.architecture .look span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
}
.four {
  margin: 4.2667vw auto 0;
  width: 92vw;
  height: 72.8vw;
}

.four div:nth-child(1) {
  float: left;
  width: 43.7333vw;
  height: 72.8vw;
  background-image: url(../assets/img/建筑智能化1_mob.png);
  background-size: 100% 100%;
  /* background-position: center; */
  background-size: cover;
  /* border: 1px dashed #808080; */
}
.four div:nth-child(3) {
  float: right;
  width: 44.2667vw;
  height: 11.7333vw;
  /* background-image: url(../assets/img/建筑智能化2_mob.png); */
  background-image: url(../assets/img/智能园区3.jpeg);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
  background-size: cover;
  background-position: center;
  margin-top: 4vw;
}
.four div:nth-child(2) {
  float: right;
  right: 0vw;
  width: 44.2657vw;
  height: 57.0667vw;
  background-image: url(../assets/img/建筑智能化4_mob.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center;
  /* border: 1px dashed #808080; */
}
.four div:nth-child(4) {
  float: left;
  margin-top: 4vw;
  left: 0vw;
  width: 43.7333vw;
  height: 20.5333vw;
  background-image: url(../assets/img/建筑智能化3_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}

.air {
  position: relative;
  margin: 10vw auto 0;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}
.air .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  color: #140047;
  font-size: 5.0667vw;
  font-family: AlibabaPuHuiTiB;
}
.air .content {
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #140047;
}
.air .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  color: #01021b;
  opacity: 0.72;
  font-family: PingFangSC-Regular, PingFang SC;
}
.air .look {
  width: 29.3333vw;
  height: 8vw;
  margin-top: 4.2667vw;
  margin-left: 33.7333vw;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5333vw;
  border: 0.2667vw solid #140047;
}
.air .look span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
}
.airthree {
  margin: 4.2667vw auto 0;
  width: 92vw;
  height: 69.0667vw;
}
.airthree div:nth-child(1) {
  float: left;
  /* background-image: url(../assets/img/中央空调节能系统1_mob.png); */
  background-image: url(../assets/img/建筑智能化3.jpg);
  width: 43.7333vw;
  height: 49.0667vw;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center;
  /* border: 1px dashed #808080; */
}

.airthree div:nth-child(2) {
  float: right;
  right: 0;
  /* background-image: url(../assets/img/中央空调节能系统2_mob.png); */
  background-image: url(../assets/img/建筑智能化2.png);
  width: 44.2667vw;
  height: 69.0667vw;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center;
  /* border: 1px dashed #808080; */
}

.airthree div:nth-child(3) {
  float: left;
  margin-top: 4vw;
  right: 0;
  /* background-image: url(../assets/img/中央空调节能系统3_mob.png); */
  background-image: url(../assets/img/建筑智能化1.png);
  width: 44.2667vw;
  height: 16vw;
  background-size: 100% 100%;
  background-size: cover;
  background-position: bottom;
  /* border: 1px dashed #808080; */
}
</style>



// WEBPACK FOOTER //
// src/components/architecture.vue